<template>
  <div class="h-screen flex items-center justify-center flex-col p-6">
    <IconTicketer class="size-9 text-muted-foreground mb-6" />
    <div class="w-full max-w-84 mx-auto">
      <slot />
    </div>
  </div>
</template>
